import DiagramType from "@core/components/Diagram/DiagramType";
import { getDiagramDescriptor } from "@ext/markdown/elements/diagrams/logic/diagramDescriptors";
import parseDiagramInfo from "@ext/markdown/elements/diagrams/logic/parseDiagramInfo";

const isFenceDiagramLang = (lang: string): boolean => {
	const { name } = parseDiagramInfo(lang);
	if (!Object.hasOwn(DiagramType, name)) return false;
	return getDiagramDescriptor(DiagramType[name]).inlineFence;
};

export default isFenceDiagramLang;
